<template>
  <AppPageCard>
    <template #card-title> {{ $t("AWAY.PERSONAL.TITLE") }} </template>
    <template #card-toolbar>
      <!-- begin: b-nav tabs  -->
      <b-nav pills class="nav-light-primary font-weight-bolder">
        <b-nav-item to="entitlement" exact exact-active-class="active"
          >Entitlement
        </b-nav-item>
        <b-nav-item to="application" exact exact-active-class="active"
          >History
        </b-nav-item>
      </b-nav>
      <!-- end: b-nav tabs  -->
    </template>
    <router-view></router-view>
  </AppPageCard>
</template>

<script>
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
export default {
  name: "PersonalAwayPage",
  components: { AppPageCard },
};
</script>

<style scoped></style>
